import axios from './JWTService';

export class CustomDomainService {
  get = (workspace_id: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`workspace/${workspace_id}/custom_domain/get`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  delete = (
    workspace_id: string,
    id: string,
    type: 'workspace' | 'all_workspaces' | string = 'workspace'
  ): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`workspace/${workspace_id}/custom_domain/delete/${id}/${type}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  create = (workspace_id: string, data: any): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`workspace/${workspace_id}/custom_domain/create`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  update = (workspace_id: string, id: string, data: any): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`workspace/${workspace_id}/custom_domain/update/${id}`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  checkConnectivity = (workspace_id: string, url: string, id: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`workspace/${workspace_id}/custom_domain/check_connectivity/${id}`, { url })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  dnsRecords = (workspace_id: string, id: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`workspace/${workspace_id}/custom_domain/dns_records/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  updateStatus = (workspace_id: string, id: string, data: any): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`workspace/${workspace_id}/custom_domain/updateStatus/${id}`, { status: data })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  // Add these new methods to the CustomDomainService class

  searchDomains = (keyword: string, tlds: string[] = ['com', 'net', 'org', 'io']): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`domains/search`, { keyword, tlds })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  checkDomainAvailability = (domainName: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`domains/check-availability`, { domain_name: domainName })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  purchaseDomain = (
    workspace_id: string,
    data: {
      domain_name: string;
      years: number;
      redirect_404_url?: string;
      branded_domain_url?: string;
      contact_info: {
        firstName: string;
        lastName: string;
        address1: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        phone: string;
        email: string;
      };
    }
  ): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`workspace/${workspace_id}/domains/purchase`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  checkPropagation = (workspace_id: string, domain_id: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`workspace/${workspace_id}/domains/check-propagation/${domain_id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  renewDomain = (workspace_id: string, domain_id: string, years: number): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`workspace/${workspace_id}/domains/renew/${domain_id}`, { years })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  toggleAutoRenewal = (workspace_id: string, domain_id: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`workspace/${workspace_id}/domains/toggle-auto-renewal/${domain_id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
}
